function floorplan() {
	const openBtns = document.querySelectorAll('.floorplan-link');
	const floorplan = document.querySelector('.floorplan-lightbox');
	const closeBtn = document.querySelector('.floorplan-lightbox__close');

	if (openBtns && floorplan) {
		openBtns.forEach(openBtn => {
			openBtn.addEventListener('click', function(e) {
				e.preventDefault();
				floorplan.classList.add('active');
			});
		});

		if (closeBtn) {
			closeBtn.addEventListener('click', function() {
				floorplan.classList.remove('active');
			});
		}
	}
}

export default floorplan;